
import * as React from "react";
import {Row } from 'antd';
import ReactECharts from 'echarts-for-react';
import { assert_key } from "../../../helper";

export interface IProps {
  fairness_package:any
}
export interface IState {
}

export default class FairnessChart extends React.Component<IProps, IState>{
    public refresh_number: any = 1;
    constructor(props:IProps) {
        super(props);
        this.renderFairnessChart = this.renderFairnessChart.bind(this);
        this.state = {
        }
        // Flow:
        // 1. Constructor
        // 2. componentWillMount()
        // 3. render()
        // 4. componentDidMount()
        // If props update:
        // 4.1 componentWillReceiveProps(nextProps : IProps), then goto 5.
        // If States update
        // 5. shouldComponentUpdate() if return false, then no rerendering.
        // 6. if True, then componentWillUpdate
        // 7. render()
        // 8. componentDidUpdate
        // If Unmount, then componentWillUnmount()
    }
    public renderFairnessChart = (fairness_package_dict:any) => {
      let flag = assert_key(fairness_package_dict, ["x_axis_data", "y_series_data"]);
      let enable_fairness_chart = flag;
      let fairness_chart_option = {};
      this.refresh_number = this.refresh_number + 1;
      
      let getStr = (params:any) => {
        return params["marker"] + params["seriesName"] + "&nbsp;&nbsp;&nbsp;&nbsp;<strong>"+ params["data"].toFixed(3)+"</strong>";
      }
      if(enable_fairness_chart){
          fairness_chart_option = {
              title: {
                //text: 'Fairness'
              },
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow'
                },
                formatter: function (params:any) {
                  console.log("tooltip", params);
                  let return_str = params[0]["name"] + "<br />";
                  for(let i = 0; i<params.length;i++){
                    let param = params[i];
                    return_str += getStr(param) + "<br />"
                  }
                  return return_str;
                  //return params["marker"] + params["name"] + "&nbsp;&nbsp;&nbsp;&nbsp;<strong>"+ params["data"].toFixed(3)+"</strong>";
                }
              },
              legend: {
                "right": 20
              },
              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
              },
              yAxis: {
                type: 'value',
                boundaryGap: [0, 0.01]
              },
              xAxis: {
                type: 'category',
                data: fairness_package_dict["x_axis_data"]
              },
              series: fairness_package_dict["y_series_data"]
            };
          
          
          return <ReactECharts key={this.refresh_number} option={fairness_chart_option} />
      }else{
          return <div />
      }
  }
    

    public render() {

        return this.renderFairnessChart(this.props.fairness_package);
    }
}